<!-- https://www.figma.com/design/K7vDg6el3Bz7MHUdlMREDj/Credit-Conversion-Statuses?node-id=2027-58&p=f&m=dev -->
<template>
  <div class="card-switch-root">
    <CardStyles />
    <!--  -->
    <CardPending v-if="status === 'pending'" :is-polling="shouldDisableButton" />
    <CardPending v-else-if="status === 'not-started'" :is-polling="false" />
    <CardSuccess v-else-if="status === 'success'" />
    <CardSuccess v-else-if="status === 'approved'" />
    <CardAlreadyProcessed v-else-if="status === 'already-processed'" />
    <CardEarlyRetry v-else-if="status === 'early-retry'" />
    <CardError v-else-if="status === 'error'" />
  </div>
</template>

<script>
import { preloadImages } from './lib/preload-images';
import { AddToTranscriptStatus } from './add-to-transcript-status';
import CardAlreadyProcessed from './card-already-processed/CardAlreadyProcessed.vue';
import CardError from './card-error/CardError.vue';
import CardEarlyRetry from './card-early-retry/CardEarlyRetry.vue';
import CardPending from './card-pending/CardPending.vue';
import CardSuccess from './card-success/CardSuccess.vue';
import CardStyles from './ui/CardStyles.vue';

export default {
  name: 'CardSwitch',
  components: {
    CardStyles,
    CardAlreadyProcessed,
    CardError,
    CardEarlyRetry,
    CardPending,
    CardSuccess
  },
  props: {
    status: {
      type: String,
      required: true,
      validator: AddToTranscriptStatus.validator
    },
    isPolling: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      AddToTranscriptStatus
    };
  },
  computed: {
    shouldDisableButton() {
      // Only disable button when actively polling and status is pending
      return this.isPolling && this.status === 'pending';
    }
  },

  mounted() {
    preloadImages({
      images: ['/art-success.gif', '/art-pending.gif', '/art-error.png']
    });
  }
};
</script>

<style scoped>
.card-switch-root {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
</style>
